export interface NavLink {
  label: string;
  menuItems: {
    path?: string; // Made optional
    externalUrl?: string; // Add this
    queryParams?: { tab: string };
    fragment?: string;
    label: string;
    category?: string;
  }[];
}

export const navLinks: NavLink[] = [
  {
    label: 'Company',
    menuItems: [
      { label: 'Home', path: '/' },
      { label: 'About Us', path: '/about-us' },
      { label: 'Join Us', path: '/contact-us' },
      { label: 'Contact Us', path: '/contact-us' },
      // { label: "Founders' Letter", path: '/a-letter-from-our-founders' },
    ],
  },
  {
    label: 'Product',
    menuItems: [
      { label: 'Pricing', path: '/pricing' },
      // { path: '/use-cases', label: 'Use Cases' },
      // { path: '/status', label: 'System Status' },
      {
        path: '/settings',
        label: 'Product Support',
        queryParams: { tab: 'support' },
      },
      {
        path: '/settings',
        label: 'Feedback',
        queryParams: { tab: 'feedback' },
      },
      { path: '/', fragment: 'community', label: 'Community' },
    ],
  },
  {
    // Mirrors the workspace header's "Partner Dashboard" entry point —
    // "Become a Partner" is open to everyone (marketing/apply flow);
    // "Partner Dashboard" is gated to ACTIVE Execution Partners only via
    // FooterComponent.isPartnerOnly() (see footer.component.ts), same
    // rule used everywhere else a partner is identified in the app.
    label: 'Execution Partners',
    menuItems: [
      { label: 'Become a Partner', path: '/execution-partners' },
      { label: 'Partner Dashboard', path: '/execution-partners/dashboard' },
    ],
  },
  {
    label: 'Important Links',
    menuItems: [
      {
        label: 'Terms & Conditions',
        path: '/terms-and-conditions',
      },
      {
        label: 'Privacy Policy',
        path: '/privacy-policy',
      },
      {
        label: 'Refund Policy',
        path: '/refund-policy',
      },
      {
        label: 'Cancellation Policy',
        path: '/cancellation-policy',
      },
      // { path: 'learn-ai', label: 'Learn AI' },
    ],
  },
];

export interface FAQ {
  question: string;
  answer: string;
}

export const FAQS: FAQ[] = [
  {
    question: 'How do I buy more credits?',
    answer:
      'You can purchase credits directly in the "Credits" tab using the Buy Credits button.',
  },
  {
    question: 'What happens if I run out of credits?',
    answer:
      'Once your credits are exhausted, you will need to buy a new bundle to continue building your app.',
  },
  {
    question: 'Can I get a refund on unused credits?',
    answer:
      'Credits are non-refundable, but they never expire — you can use them anytime.',
  },
  {
    question: 'Where can I see my ticket status?',
    answer:
      'Our support team will reply via email, and updates will also appear under your Tickets tab.',
  },
  {
    question: 'How many credits do I need for a full app?',
    answer:
      'It depends on complexity. A small app may take 20–30 credits, while larger apps can use 100+ credits.',
  },
  {
    question: 'Do credits expire?',
    answer: 'No, your credits never expire. You can use them anytime.',
  },
  {
    question: 'Can I transfer credits to another account?',
    answer: 'No, credits are tied to your account and cannot be transferred.',
  },
  {
    question: 'What kind of code do I get when I spend credits?',
    answer:
      'You get production-ready Angular code using Angular Material, fully editable and deployable.',
  },
  {
    question: 'Can I download my generated code?',
    answer:
      'Yes, all generated code can be downloaded and integrated into your projects.',
  },
  {
    question: 'Can I use my own Angular project with Angularize?',
    answer:
      'Yes, you can copy and paste generated components into any Angular project you already have.',
  },
  {
    question: 'Do I need coding skills to use Angularize?',
    answer:
      'No, you can build apps using prompts. However, coding knowledge helps in customizing further.',
  },
  {
    question: 'What if I face issues while generating components?',
    answer:
      'You can raise a support ticket under the "Support" tab, and our team will assist you.',
  },
  {
    question: 'Can I use Angularize for commercial apps?',
    answer:
      'Yes, you own the code generated and can use it for personal or commercial projects without restrictions.',
  },
  {
    question: 'Does Angularize support Angular Universal (SSR)?',
    answer:
      'Yes, you can generate code compatible with Angular Universal for server-side rendering.',
  },
  {
    question: 'Is my generated code optimized for performance?',
    answer:
      'Yes, the generated code follows Angular best practices and Material guidelines for performance and UI consistency.',
  },
  {
    question: 'Can I cancel my credits purchase?',
    answer:
      'All purchases are final and non-refundable, but your credits will remain in your account indefinitely.',
  },
  {
    question: 'Is there a free trial?',
    answer:
      'Yes, every new account starts with free credits to test and explore the platform.',
  },
  {
    question: 'How secure is my data?',
    answer:
      'Your projects and generated code are stored securely in Firebase, accessible only to you.',
  },
  {
    question: 'Can I collaborate with teammates?',
    answer:
      'Collaboration features are planned. For now, you can share downloaded code with your team manually.',
  },
  {
    question: 'How do I report bugs or suggest features?',
    answer:
      'You can raise a ticket under "Support" or write feedback in feedback section or email us directly with feedback and feature requests to angularize.dev@gmail.com.',
  },
];